import axios from "axios";
import store from "@/store";
import * as Sentry from "@sentry/react";
import { updateErrorStatusCode } from "@/features/errorStatusCodeSlice";

const axiosInstance = axios.create({
    baseURL: process.env.VITE_API_DOMAIN || "/api",
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status >= 500 && error.response.status < 600) {
                store.dispatch(updateErrorStatusCode(true));
                Sentry.captureException(new Error(error.response.data.message));
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
